import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let person_id = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'person_id',
  })

  return {
    variables: {
      person_id,
    },
    pause: !person_id,
  }
}
